import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import './profileHeader.css';

const ProfileHeader = ({ data, title, activePage, showBackArrow = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const normalizePath = (path) => path.replace(/^\/|\/$/g, '');
  const shouldShowBackArrow =
    showBackArrow && normalizePath(location.pathname) === normalizePath(activePage);

  return (
    <div className="header-container">
      <div className="header-side">
        {shouldShowBackArrow && (
          <button 
            className="header-back-button" 
            onClick={() => {
              if (window.history.length > 2) {
                navigate(-1);
              } else {
                navigate('/');
              }
            }}
          >
            ←
          </button>
        )}
        <button className="header-button" onClick={() => navigate('/profile')}>
          <img 
            src={data?.photo || '/images/default-avatar.png'} 
            alt="Profile" 
            className="header-photo" 
          />
        </button>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <h3>{data?.title}</h3>
          <p>{data?.subTitle}</p>
        </div>
      </div>

      <div className="header-side" />
    </div>
  );
};

export default ProfileHeader;